import { Controller } from "@hotwired/stimulus"

// クリップボードへコピーする制御
export default class extends Controller {
  static targets = ["source"]

  async copy(event) {
    const text = this.sourceTarget.textContent.trim()
    try {
      await navigator.clipboard.writeText(text)
      this.flashLabel(event.currentTarget, "コピーしました")
    } catch (_e) {
      this.flashLabel(event.currentTarget, "コピーに失敗しました")
    }
  }

  flashLabel(button, message) {
    const original = button.textContent
    button.textContent = message
    button.disabled = true
    setTimeout(() => {
      button.textContent = original
      button.disabled = false
    }, 1500)
  }
}
